import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/icons/odo.png';

export const Forbidden: React.FC = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/home');
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
                <div className="mb-8">
                    <img src={logo} alt="Company Logo" className="h-16 mx-auto mb-6" />
                </div>

                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-gray-300">403</h1>
                    <h2 className="text-2xl font-semibold text-gray-700 mb-4">Access Denied</h2>
                    <p className="text-gray-500 mb-8">
                        You don't have permission to access this patient.
                    </p>
                </div>

                <div className="space-y-4">
                    <button
                        onClick={handleGoHome}
                        className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                    >
                        Go to Home
                    </button>

                    <div className="text-sm text-gray-400">
                        <button
                            onClick={() => window.history.back()}
                            className="hover:text-gray-600 transition-colors"
                        >
                            ← Go back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
